import { Store } from "@/stores/common/store.core";
import type { StoreJsonResponse } from "@/stores/common/store.core";
import type { Attachment } from "@/react/prop-types";
import type { ResponsePayload } from "@laborchart-modules/common/dist/api";
import type { GetSignedURLResponse } from "@laborchart-modules/lc-core-api/dist/api/attachments/signed-url";

export abstract class AttachmentStore extends Store {
   static createAttachment(data: {
      name: string;
      mimetype: string;
      bytes: number;
   }): StoreJsonResponse<ResponsePayload<Attachment>> {
      return this.requestJson({
         url: `/api/v3/attachments`,
         method: "POST",
         body: data,
      });
   }

   static deleteAttachment(attachmentId: string): StoreJsonResponse<boolean> {
      return this.requestJson({
         url: `/api/v3/attachments/${attachmentId}`,
         method: "DELETE",
      });
   }

   static uploadFile(fileId: string, formData: FormData): StoreJsonResponse<boolean> {
      return this.requestJson({
         url: `/api/v3/attachments/${fileId}`,
         method: "POST",
         body: formData,
      });
   }

   static getSignedUrl(url: string): StoreJsonResponse<GetSignedURLResponse> {
      return this.requestJson({
         method: "GET",
         url,
      });
   }
}
